import { useEffect, useState } from "react";
import { getSettings } from "../../lib/api";

const STORAGE_KEY = "ssd-consent-v1";

function readConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

function injectScript(id, src, inline) {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id;
  if (src) { s.src = src; s.async = true; }
  if (inline) s.innerHTML = inline;
  document.head.appendChild(s);
}

/**
 * Loads Google Analytics 4 and the Meta Pixel ONLY after the matching cookie
 * consent has been granted (DSGVO-konform). IDs come from the CMS settings.
 */
export default function TrackingScripts() {
  const [settings, setSettings] = useState({});
  const [consent, setConsent] = useState(() => readConsent());

  useEffect(() => { getSettings().then(setSettings).catch(() => {}); }, []);

  useEffect(() => {
    const onChange = (e) => setConsent(e.detail || readConsent());
    window.addEventListener("consent-changed", onChange);
    return () => window.removeEventListener("consent-changed", onChange);
  }, []);

  useEffect(() => {
    if (!consent) return;
    const ga = (settings.tracking_ga4 || "").trim();
    const pixel = (settings.tracking_meta_pixel || "").trim();

    if (ga && consent.statistik && !document.getElementById("ga4-src")) {
      injectScript("ga4-src", `https://www.googletagmanager.com/gtag/js?id=${ga}`);
      injectScript("ga4-init", null,
        `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}` +
        `gtag('js',new Date());gtag('config','${ga}',{anonymize_ip:true});`);
    }

    if (pixel && consent.marketing && !document.getElementById("meta-pixel")) {
      injectScript("meta-pixel", null,
        `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?` +
        `n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;` +
        `n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;` +
        `t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}` +
        `(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');` +
        `fbq('init','${pixel}');fbq('track','PageView');`);
    }
  }, [consent, settings]);

  return null;
}
